// extracted by mini-css-extract-plugin
export default {"sectionTitle":"SecurityAssessment_sectionTitle__hfvWd","introText":"SecurityAssessment_introText__r5jIw"};